import React from "react";
import styles from "../DressingChangeFrequency.module.scss";
import type { CalendarCell, Schedule } from "../types";

interface CalendarStripProps {
  strip: CalendarCell[];
  schedule: Schedule;
}

export const CalendarStrip: React.FC<CalendarStripProps> = ({ strip, schedule }) => (
  <div className={styles.panel_column}>
    <span className={styles.panel_label}>Next 14 days</span>
    <div className={styles.calendar_grid}>
      {strip.map((cell) => (
        <div key={cell.key} title={cell.title} className={styles.calendar_cell}>
          <span className={styles.calendar_dow}>{cell.dow}</span>
          <span className={cell.markClass}>{cell.date}</span>
          <span className={styles.calendar_count}>{cell.countLabel}</span>
        </div>
      ))}
    </div>
    {schedule.mode === "prn" && (
      <div className={styles.legend_row}>
        <span className={styles.legend_item}>
          <span className={`${styles.legend_dot} ${styles.legend_dot_dashed}`} />
          Change if needed
        </span>
        <span className={styles.legend_item}>
          <span className={`${styles.legend_dot} ${styles.legend_dot_solid}`} />
          Change no later than
        </span>
      </div>
    )}
  </div>
);
